import React from 'react';
import styled from '@emotion/styled';
import { useTranslation } from 'react-i18next';
import { scVarTransitionDuration } from '@utils/emotion/variables';

const CardCreatorGuide: React.FC = () => {
  const { t } = useTranslation();

  return (
    <CardBlock>
      <GuideModalTitleBlock>{t('upload.guide.title')}</GuideModalTitleBlock>
      <GuideModalDescBlock>
        <p className="desc">{t('upload.guide.description')}</p>
        <ul className="conditions">
          <li className="condition">
            <span className="image">
              <img src="/assets/guide/upload/item1.png" alt="" />
            </span>
            <p className="text" dangerouslySetInnerHTML={{ __html: t('upload.guide.guide1') }} />
          </li>
          <li className="condition">
            <span className="image">
              <img src="/assets/guide/upload/item2.png" alt="" />
            </span>
            <p className="text" dangerouslySetInnerHTML={{ __html: t('upload.guide.guide2') }} />
          </li>
          <li className="condition">
            <span className="image">
              <img src="/assets/guide/upload/item3.png" alt="" />
            </span>
            <p className="text" dangerouslySetInnerHTML={{ __html: t('upload.guide.guide3') }} />
          </li>
          <li className="condition">
            <span className="image">
              <img src="/assets/guide/upload/item4.png" alt="" />
            </span>
            <p className="text" dangerouslySetInnerHTML={{ __html: t('upload.guide.guide4') }} />
          </li>
          <li className="condition">
            <span className="image">
              <img src="/assets/guide/upload/item5.png" alt="" />
            </span>
            <p className="text" dangerouslySetInnerHTML={{ __html: t('upload.guide.guide5') }} />
          </li>
          <li className="condition">
            <span className="image">
              <img src="/assets/guide/upload/item6.png" alt="" />
            </span>
            <p className="text" dangerouslySetInnerHTML={{ __html: t('upload.guide.guide6') }} />
          </li>
        </ul>
      </GuideModalDescBlock>
    </CardBlock>
  );
};

const CardBlock = styled.div`
  position: relative;
  width: 350px;
  min-height: 438px;
  padding: 22px;
  background-color: ${({ theme }) => theme.colors.secondary.bgColor};
  box-shadow: 0px 4px 4px rgba(12, 9, 9, 0.1);
  transition: background-color ${scVarTransitionDuration} ease;
`;

const GuideModalTitleBlock = styled.strong`
  display: block;
  font-size: 18px;
  line-height: 1.5;

  .icon {
    display: inline-block;
    margin-right: 8px;
    vertical-align: top;
    line-height: 0;
  }
`;

const GuideModalDescBlock = styled.div`
  .desc {
    margin-top: 14px;
    font-weight: normal;
    font-size: 12px;
    line-height: 18px;
    color: #334d6e;
  }

  .conditions {
    margin: 18px 0 0;
    padding: 0;
  }

  .condition {
    display: flex;
    align-items: center;
    position: relative;
    min-height: 103px;
    margin: 9px 0 0;
    padding: 32px 38px 32px 106px;
    background-color: #f5f6f8;
    list-style: none;
    font-weight: bold;
    font-size: 14px;
    line-height: 21px;
    word-break: break-word;
    color: #334d6e;

    &:first-of-type {
      margin-top: 0;
    }

    .image {
      display: flex;
      align-items: center;
      position: absolute;
      top: 0;
      left: 0;
      bottom: 0;
      max-width: 101px;

      img {
        display: block;
        width: 100%;
      }
    }

    .text {
      margin: 0;

      .type-allowed {
        color: #52c41a;
      }

      .type-disallowed {
        color: #f5222d;
      }
    }
  }
`;

export default CardCreatorGuide;
